import DownloadIcon from '@mui/icons-material/Download';
import {
    Alert,
    Avatar,
    Box,
    Button,
    Collapse,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Snackbar,
    TextField,
    Toolbar,
    Tooltip,
    Typography
} from '@mui/material';
import {AgGridReact} from 'ag-grid-react';
import dayjs from 'dayjs';
import {useEffect, useRef, useState} from 'react';
import httpReq from '../services/httpReq';
import {ActionsToolBar} from '../components/grid/ActionsToolbar';
import HomeMadeSnackbar from '../components/snackbars/HomeMadeSnackbar';
import ModalViewReport from '../components/modals/asiaReports/ModalViewReport';
import {CheckBoxOutlineBlank, CheckBoxOutlined, Close, FilterAlt, Folder, RestartAlt} from "@mui/icons-material";
import FullPageLoader from "../components/loaders/FullPageLoader";
import useMobile from "../hooks/useMobile";
import PaginationControls from "../components/grid/PaginationControls";
import {download, generateCsv, mkConfig} from "export-to-csv";
import {msg} from "@lingui/macro";
import {useLingui} from "@lingui/react";
import Autocomplete from "@mui/material/Autocomplete";
import * as lod from "lodash";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {BASE_URL} from "../consts/BaseUrl";



const ReportsPage = () => {
    const isMobile = useMobile();

    const [rowsData, setRowsData] = useState([])
    const [reportsList, setReportsList] = useState([])
    const [reportTagList, setReportTagList] = useState([])
    const [reportTypeList, setReportTypeList] = useState([])
    const [rowToEdit, setRowToEdit] = useState(null)
    const [rowToDelete, setRowToDelete] = useState(null)
    const [isModalAddOpen, setIsModalAddOpen] = useState(false)
    const [isModalEditOpen, setIsModalEditOpen] = useState(false)
    const [isModalViewOpen, setisModalViewOpen] = useState(false)
    const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState(false)
    const [isOpenSnackbar, setisOpenSnackbar] = useState(false)
    const [snackbarValues, setSnackbarValues] = useState({
        btnColor: '',
        color: '',
        closeAction: true,
        message: ''
    })
    const [projectList, setProjectList] = useState([])
    const [selectedProject, setSelectedProject] = useState(null)
    const gridRef = useRef(null)
    const [isLoading, setIsLoading] = useState(false)
    const [pageIndex, setPageIndex] = useState(0)
    const [pageSize, setPageSize] = useState(50)
    const [pagesNumber, setPagesNumber] = useState(null)
    const [recordsCount, setRecordsCount] = useState(null)
    const [snackbarCsvVis, setSnackbarCsvVis] = useState(false)
    const {_} = useLingui()
    const [filtersOpen, setFiltersOpen] = useState(false)
    const [selectedTagValues, setSelectedTagValues] = useState([])
    const [selectedTags, setSelectedTags] = useState([])

    useEffect(() => {
        if (!selectedProject) {
            getReportsList()
        } else {
            getReportsListByFilters()
        }

    }, [pageIndex, pageSize]);

    const getProjectList = async () => {
        const res = await httpReq('/Project/GetList', 'GET', null, true)
        if (!res.responseAnyError) {
            setProjectList(res.responseData)
        }
    }

    const getReportsList = async () => {
        setIsLoading(true)
        const body = {
            pageSize: pageSize,
            pageIndex: pageIndex + 1
        }
        const res = await httpReq('Report/GetList', 'POST', body, true)
        if (res && !res.responseAnyError) {
            setReportsList(res.responseData)
            const w = res.responseData.map(d => {
                d.reporterCompleteName = d.reporter.completeName
                return d
            })
            setRowsData(w)
            const bodyPagesCount = {
                pageIndex: pageIndex + 1,
                pageSize: pageSize,
                tagValuesFk: [],
                projectFk:null
            }
            const resPagesCount = await httpReq('Report/GetPagesCount', 'POST', bodyPagesCount, true)
            if(resPagesCount && !resPagesCount.responseAnyError){
                setPagesNumber(resPagesCount.responseData.pagesCount)
                setRecordsCount(resPagesCount.responseData.recordsCount)
            }


        }
        setIsLoading(false)
    }

    const getReportsListByFilters = async () => {
        setIsLoading(true)
        const body = {
            pageIndex: pageIndex + 1,
            pageSize: pageSize,
            tagValuesFk: selectedTagValues,
            projectFk: selectedProject.id
        }
        const url = `Report/GetList`
        const res = await httpReq(url, 'POST', body, true)
        if(!res || res.responseAnyError) return;
        if (res && !res.responseAnyError) {
            setReportsList(res.responseData)
            const w = res.responseData.map(d => {
                d.reporterCompleteName = d.reporter.completeName
                return d
            })
            setRowsData(w)
            const bodyPagesCount = {
                pageIndex: pageIndex + 1,
                pageSize: pageSize,
                tagValuesFk: selectedTagValues,
                projectFk: selectedProject.id
            }
            const resPagesCount = await httpReq('Report/GetPagesCount','POST',bodyPagesCount, true)
            if(resPagesCount && !resPagesCount.responseAnyError){
                setPagesNumber(resPagesCount.responseData.pagesCount)
                setRecordsCount(resPagesCount.responseData.recordsCount)
            }


        }
        setIsLoading(false)
    }

    const getReportTypeList = async () => {
        const res = await httpReq('ReportType/GetList', 'GET', null, true)
        if(!res || res.responseAnyError) return;
        if (!res.responseAnyError) {
            const data = res.responseData
            setReportTypeList(data)
        }
    }



    const updateLoading = (tagIndex, tagValueIndex, isLoading) => {
        const newTags = [...reportTagList];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].isLoading = isLoading;
        newTags[tagIndex].values = tagValues;
        setReportTagList(newTags);
    }

    const updateLoaded = (tagIndex, tagValueIndex, isLoading) => {
        const newTags = [...reportTagList];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].isLoaded = isLoading;
        newTags[tagIndex].values = tagValues;
        setReportTagList(newTags);
    }

    const updateImage = (tagIndex, tagValueIndex, fileSrc) => {
        const newTags = [...reportTagList];
        const tagValues = [...newTags[tagIndex].values];
        tagValues[tagValueIndex].fileSrc = fileSrc;
        newTags[tagIndex].values = tagValues;
        setReportTagList(newTags);
    }

    useEffect(() => {
        httpReq('/Tag/GetList', 'GET', null, true).then(res => {
            if(!res || res.responseAnyError) return;
            const newTags = [...res.responseData].map((item) => {
                item.open = false;
                item.values = item.values.map((value) => {
                    value.isLoading = false;
                    value.isLoaded = false;
                    return value;
                });
                return item;
            });
            const v = [...lod.orderBy(newTags, ['orderIndex'], 'asc')]
            setReportTagList(v);
        });

    }, []);

    useEffect(() => {
        reportTagList.forEach((tag, tagIndex) => {
            const values = tag.values;
            values.forEach((value, tagValueIndex) => {
                if (value.isLoaded === false && value.isLoading === false && value.fileContent === '') {
                    updateLoading(tagIndex, tagValueIndex, true);
                    httpReq('/TagValue/Get/'+value.id, 'GET',null,true) .then(res => {
                        if(!res || res.responseAnyError) return;
                        const tagValue = res.responseData;
                        if (tagValue.fileContent) {
                            const fileSrc = "data:" + tagValue.fileMimeType + ";base64," + tagValue.fileContent;
                            updateImage(tagIndex, tagValueIndex, fileSrc);
                        }
                        updateLoading(tagIndex, tagValueIndex, false);
                        updateLoaded(tagIndex, tagValueIndex, true);
                    });


                }
            })
        })

    }, [reportTagList])

    {/*
    useEffect(() => {
        if (!isModalAddOpen) {
            getReportsList()
        }
    }, [isModalAddOpen])

    useEffect(() => {
        if (!isModalEditOpen) {
            getReportsList()
        }
    }, [isModalEditOpen])

    useEffect(() => {
        getReportsList()
    }, [isOpenDeleteDialog])
*/
    }
    useEffect(() => {

        getReportsList()
        getReportTypeList()
        // getReportTagList()
        getProjectList()

    }, [])

    const deleteReport = async () => {
        const res = await httpReq(`Report/Delete/${rowToDelete.id}`, 'DELETE', null, true)
        if(!res || res.responseAnyError) return;
        if (!res.responseAnyError) {
            setRowToDelete(null)
            setIsOpenDeleteDialog(false)
        }
    }

    const downloadReportsList = async () => {
        setSnackbarCsvVis(true)
        const today = dayjs(new Date()).format('YYYY-MM-DD HH:mm')

        //DONE Bug fixing
        // const url = `Report/GetListByProject/${selectedProject.id}`
        // const body = {
        //     pageSize: 0,
        //     pageIndex: 0
        // }
        const url = `Report/GetList`
        const body = {
            pageSize: 0,
            pageIndex: 0,
            tagValuesFk: selectedTagValues,
            projectFk: selectedProject.id
        }
        httpReq(url, 'POST', body, true).then(res => {
            if(!res || res.responseAnyError) return;
            const csvConfig = mkConfig({useKeysAsHeaders: true, filename: `reports-list-${today}`});
            const mappedReportsList = [...res.responseData].map(({
                                                                     manager,
                                                                     reportAttachments,
                                                                     tagValues,
                                                                     ...report
                                                                 }) => {
                report.video = report.video.fileName
                report.reporter = report.reporter.completeName
                return report;
            })
            const csv = generateCsv(csvConfig)((mappedReportsList))
            download(csvConfig)(csv)
        }).finally(()=>  setSnackbarCsvVis(false));
        // const res = await httpReq(url, 'POST', body, true)
        // if (!res.responseAnyError) {
        //     const csvConfig = mkConfig({useKeysAsHeaders: true, filename: `reports-list-${today}`});
        //     const mappedReportsList = [...res.responseData].map(({
        //                                                              manager,
        //                                                              reportAttachments,
        //                                                              tagValues,
        //                                                              ...report
        //                                                          }) => {
        //         report.video = report.video.fileName
        //         report.reporter = report.reporter.completeName
        //         return report;
        //     })
        //
        //     const csv = generateCsv(csvConfig)((mappedReportsList))
        //     download(csvConfig)(csv)
        // }
        // setSnackbarCsvVis(false)

    }

    {/*
    const downloadReportList = () => {
        const today = dayjs(new Date()).format('YYYY-MM-DD')
        const fileName = !!selectedProject ? `${today}_${selectedProject.name}_report_list` : `${today}_report_list`

        gridRef.current.api.exportDataAsCsv({
            columnKeys: [
                'title',
                'description',
                'reporterCompleteName',
                'video.project.name',
                'video.description',
                'tagValuesDesc',
                'latitude',
                'longitude'
            ],
            fileName: fileName,
        })
    }
    */
    }

    const handleSelectedProject = (value) => {
        setRowsData(reportsList)
        if (value) {
            const foundedProject = projectList.find(u => {
                return u.name === value.name
            })
            setSelectedProject(foundedProject)
            // getReportsListByFilters(foundedProject)
        } else {
            setSelectedProject(null)
            setRowsData(reportsList)
        }
        //setRowsData(dataFiltered)
    }

    const isInSelectedTags = (tag) => {
        const idx = selectedTags.findIndex(u => u === tag.id);
        return idx > -1
    }

    const isInSelectedTagValues = (value) => {
        const idx = selectedTagValues.findIndex(id => id === value.id);
        return idx > -1
    }

    const manageSelectedValues = (tag) => {
        const copyTags = [...selectedTags];
        const copyValues = [...selectedTagValues]
        const tagValues = tag.values
        const idx = copyTags.findIndex(t => t === tag.id)
        if (idx === -1) {
            copyTags.push(tag.id);
            //
            tagValues.forEach((value, index) => {
                const idx = copyValues.findIndex(t => t === value.id);
                if(idx === -1){
                    copyValues.push(value.id)
                }
            })
            setSelectedTagValues(copyValues)
        } else {
            copyTags.splice(idx, 1)
            tagValues.forEach((value, index) => {
                const idx = copyValues.findIndex(t => t === value.id);
                if(idx > -1){
                    copyValues.splice(idx,1)
                }
            })
            setSelectedTagValues(copyValues)
        }
        setSelectedTags(copyTags)
    }


    const ToolBar = (props) => {
        let selectedRow = props.node.data;

        const editAction = () => {
            setRowToEdit(selectedRow)
            setIsModalEditOpen(true)
        };

        const viewAction = () => {
            setRowToEdit(selectedRow)
            setisModalViewOpen(true)
        }

        const customActions = [
            {
                action: viewAction,
                disabled: false,
                icon: 'view',
                label: 'View report',
                tooltip: 'View report'
            }
        ];

        const deleteAction = () => {
            setRowToDelete(selectedRow)
            setIsOpenDeleteDialog(true)
        };

        return <ActionsToolBar
            customActions={customActions}
        />
    };

    let initColumns = [
        {
            field: 'title'
            , headerName: 'Title'
            , flex: 3
            , filter: true
        },
        {
            field: 'description'
            , headerName: 'Description'
            , flex: 3
            , filter: true
        },
        {
            field: 'reporterCompleteName'
            , headerName: 'Reporter'
            , flex: 3
            , filter: true
        },
        {
            field: 'video.project.name',
            headerName: 'Project'
            , flex: 3
            , filter: true
        },
        {
            field: 'video.description',
            headerName: 'Video',
            flex: 3
            , filter: true
        },
        {
            field: 'tagValuesDesc',
            headerName: 'Tag Values',
            hide: true
        },
        {
            field: 'latitude',
            headerName: 'Latitude',
            hide: true
        },
        {
            field: 'longitude',
            headerName: 'Longitude',
            hide: true
        },
        {
            headerName: 'Details',
            flex: !isMobile ? 1 : 2,
            cellRenderer: ToolBar
        }

    ]

    const [colsLabel, setColumns] = useState(initColumns)

    return (
        <>
            <Box sx={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Toolbar sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Box sx={{display: 'flex', flexDirection: 'row', flex: 2, alignItems: 'center', gap: 2, mt: 2}}>
                        <Typography sx={{fontSize: 15, fontWeight: 700}}>Report list</Typography>
                        {/*
                        <FormControl sx={{width: '30%'}}>
                            <InputLabel id="label-select-user-role">Select a project to filter</InputLabel>
                            <Select
                                label={'Select a project to filter'}
                                value={selectedProject?.name || ''}
                                onChange={(e) => {
                                    handleSelectedProject(e)
                                }} width={'100%'} labelId="label-select-user-role">

                                {projectList.map((project, k) => {
                                    return (
                                        <MenuItem key={k} value={project.name}>{project.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        */}
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'row', gap: 2}}>
                        <Tooltip title={'Filter'}>
                            <Button variant={'contained'} onClick={() => {
                                setFiltersOpen(true)
                            }}>
                                <FilterAlt/>
                            </Button>
                        </Tooltip>
                        <Tooltip title="Reset filter">
                            <Button  onClick={() => {
                                setRowsData(reportsList)
                                setSelectedProject(null)
                                setSelectedTags([])
                                setSelectedTagValues([])
                                getReportsList()
                            }} variant={'contained'}>
                                <RestartAlt/>
                            </Button>
                        </Tooltip>
                        <Tooltip title="Download csv">
                            <Button disabled={reportsList.length <= 0 || !selectedProject || snackbarCsvVis}
                                    onClick={() => {
                                        downloadReportsList()
                                    }} variant='contained'>
                                <DownloadIcon/>
                            </Button>
                        </Tooltip>
                        {/**
                         <Button disabled={reportsList.length <= 0} onClick={() => {
                         downloadReportList('excel')
                         }} variant='contained'>Download Excel</Button>
                         */}
                    </Box>
                </Toolbar>
                {!isOpenDeleteDialog &&
                    <div style={{margin: 10, height: '100%'}}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={rowsData}
                            columnDefs={colsLabel}
                            defaultColDef={{

                                sortable: true,
                                resizable: true,
                                floatingFilter: true
                            }}
                        />
                    </div>
                }
                <PaginationControls recordsCount={recordsCount} pagesNumber={pagesNumber} rowsPerPage={pageSize} setRowsPerPage={setPageSize}
                                    pageIndex={pageIndex} setPageIndex={setPageIndex} maxPage={undefined}/>
            </Box>
            {isModalViewOpen &&
                <ModalViewReport isMobile={isMobile}
                                 row={rowToEdit}
                                 reportTypeList={reportTypeList}
                                 reportTagList={reportTagList}
                                 setIsModalOpen={setisModalViewOpen}
                                 isModalOpen={isModalViewOpen}
                />
            }

            {isOpenSnackbar &&
                <HomeMadeSnackbar
                    btnColor={snackbarValues.btnColor}
                    closeAction={snackbarValues.closeAction}
                    color={snackbarValues.color}
                    message={snackbarValues.message}
                    setIsOpen={setisOpenSnackbar}

                />
            }
            {snackbarCsvVis &&
                <Snackbar
                    open={snackbarCsvVis}
                    sx={{mt: 10}}
                    anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                >
                    <Alert severity="info" variant="filled" sx={{width: '100%'}}>
                        {_(msg`Download csv in corso...`)}
                    </Alert>
                </Snackbar>}
            {isLoading && <FullPageLoader/>}

            <Drawer
                anchor="left"
                open={filtersOpen}
                onClose={() => setFiltersOpen(false)}
                PaperProps={{
                    sx: {
                        width: isMobile ? '100%' : 400,
                        p: 2,
                    },
                }}
                transitionDuration={300}
            >
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Typography
                            variant="h6"
                            sx={{ flex: 1, textAlign: 'center', fontWeight: 600 }}
                        >
                            {_(msg`Filter reports`)}
                        </Typography>
                        <IconButton onClick={() => setFiltersOpen(false)}>
                            <Close />
                        </IconButton>
                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            gap: 2,
                            mb: 3,
                            alignItems: 'center',
                        }}
                    >
                        <Autocomplete
                            sx={{ flex: 2 }}
                            options={projectList}
                            getOptionLabel={(project) => project.name}
                            value={selectedProject}
                            onChange={(event, newValue) => {
                                setSelectedProject(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label={_(msg`Project`)} variant="outlined" size="small" />
                            )}
                        />
                        <Button
                            sx={{ flex: 1 }}
                            variant="contained"
                            disabled={!selectedProject}
                            onClick={getReportsListByFilters}
                        >
                            Apply
                        </Button>
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                        Tags
                    </Typography>

                    <List dense disablePadding>
                        {reportTagList.map((tag, idx) => (
                            <Box key={idx}>
                                <ListItem
                                    sx={{
                                        borderRadius: 2,
                                        bgcolor: 'grey.100',
                                        mb: 0.5,
                                        px: 2,
                                        py: 1,
                                        transition: '0.2s',
                                        '&:hover': {
                                            bgcolor: 'primary.light',
                                            color: 'primary.contrastText',
                                        },
                                    }}
                                >
                                    <ListItemIcon>
                                        <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32 }}>
                                            <Folder fontSize="small" sx={{ color: '#fff' }} />
                                        </Avatar>
                                    </ListItemIcon>

                                    <ListItemText
                                        primary={tag.name}
                                        primaryTypographyProps={{
                                            fontWeight: 600,
                                            fontSize: '0.95rem',
                                        }}
                                    />

                                    <IconButton
                                        onClick={() => manageSelectedValues(tag)}
                                        sx={{
                                            ml: 'auto',
                                        }}
                                        size="small"
                                    >
                                        {isInSelectedTags(tag) ? <CheckBoxOutlined /> : <CheckBoxOutlineBlank />}
                                    </IconButton>

                                    <IconButton
                                        onClick={() => {
                                            tag.open = !tag.open;
                                            const tags = [...reportTagList];
                                            tags[idx] = tag;
                                            setReportTagList(tags);
                                        }}
                                        size="small"
                                    >
                                        {tag.open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
                                    </IconButton>
                                </ListItem>

                                <Collapse in={tag.open} unmountOnExit>
                                    <List dense sx={{ pl: 6, maxHeight: 300, overflowY: 'auto', mb: 1 }}>
                                        {tag.values?.length > 0 && !isLoading ? (
                                            tag.values.map((value, k) => (
                                                <ListItem
                                                    key={k}
                                                    sx={{
                                                        px: 1,
                                                        py: 0.5,
                                                        borderRadius: 1,
                                                        '&:hover': {
                                                            bgcolor: 'action.hover',
                                                        },
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <Avatar
                                                            src={value.fileSrc}
                                                            alt={value.value}
                                                            sx={{
                                                                width: 28,
                                                                height: 28,
                                                                bgcolor: 'grey.200',
                                                            }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={value.value}
                                                        primaryTypographyProps={{
                                                            fontStyle: 'italic',
                                                            fontSize: '0.9rem',
                                                        }}
                                                    />
                                                    <IconButton
                                                        onClick={() => {
                                                            const copyTagValues = [...selectedTagValues];
                                                            const idx = copyTagValues.findIndex((v) => v === value.id);
                                                            if (idx === -1) {
                                                                copyTagValues.push(value.id);
                                                            } else {
                                                                copyTagValues.splice(idx, 1);
                                                            }
                                                            setSelectedTagValues(copyTagValues);
                                                        }}
                                                        size="small"
                                                    >
                                                        {isInSelectedTagValues(value) ? <CheckBoxOutlined /> : <CheckBoxOutlineBlank />}
                                                    </IconButton>
                                                </ListItem>
                                            ))
                                        ) : (
                                            <Typography
                                                sx={{
                                                    fontSize: '0.85rem',
                                                    textAlign: 'center',
                                                    mt: 1,
                                                    color: 'text.secondary',
                                                }}
                                            >
                                                {_(msg`Nessun tag trovato.`)}
                                            </Typography>
                                        )}
                                    </List>
                                </Collapse>
                            </Box>
                        ))}
                    </List>
                </Box>
            </Drawer>
        </>
    )
}
export default ReportsPage
